{
  "home": {
    "title": "Network Intelligence",
    "welcome": "Welcome. Network applications mount their routes into this shell."
  }
}
